export default __webpack_public_path__ + "static/media/calendar-Blue.f5ca65a3.svg";